module.exports = __webpack_public_path__ + "static/media/31JFA7.7ae6b6a7.jpg";